export default __webpack_public_path__ + "static/img-media-global-vc-56b11fe743cd03acec93ca537bac1813.jpeg";